// ============================================================================
// Page d'exercice élève — /learn/$subject/$level/$chapter/$exercise et
// /learn/exercise/$exercise (+ aperçu tuteur via `previewMode`).
// ============================================================================
// Zéro V1 (2026-10-05) : tous les exercices sont en V2 (`exercise_blocks`) et
// passent par `ExercisePlayerV2`. L'ancien player V1 (`exercise_steps`,
// RPC `get_exercise_for_student` / `submit_step_answer` / `get_attempt_progress`)
// est supprimé ; les tables V1 restent en lecture seule pour l'historique des
// tentatives (`get_attempt_review`).
// ============================================================================

import { useParams } from '@tanstack/react-router';
import { BookOpen } from 'lucide-react';
import { MarkdownMath } from '@jeraisonne/ui';
import { ExercisePlayerV2 } from '@/features/exercise-player-v2';

// ─── Situation card (contexte commun) ────────────────────────────────────────

/**
 * Affiche le « contexte commun » (`exercises.context_md`) — le scénario et les
 * données nécessaires pour résoudre l'exercice. C'est un contenu COMPLÉMENTAIRE
 * de `statement_md` (les notations), pas un doublon : les deux doivent être
 * visibles, sur l'écran d'intro comme pendant l'exercice.
 */
export function SituationCard({ content }: { content: string }) {
  return (
    <div className="border-primary-200 bg-primary-50/40 rounded-2xl border p-4 sm:p-5">
      <div className="mb-2 flex items-center gap-1.5">
        <BookOpen className="text-primary-500 h-4 w-4 shrink-0" />
        <p className="font-display text-primary-600 text-[11px] font-semibold uppercase tracking-[.1em]">
          La situation
        </p>
      </div>
      <div className="prose prose-sm text-ink-700 max-w-none text-sm">
        <MarkdownMath>{content}</MarkdownMath>
      </div>
    </div>
  );
}

// ─── Page ─────────────────────────────────────────────────────────────────────

export function ExercisePage(
  props: {
    previewMode?: boolean;
    previewExerciseId?: string;
    onExitPreview?: () => void;
  } = {},
) {
  const params = useParams({ strict: false });
  const exerciseId = props.previewMode
    ? (props.previewExerciseId ?? '')
    : (params['exercise'] ?? '');
  if (!exerciseId) return null;
  return (
    <ExercisePlayerV2
      exerciseId={exerciseId}
      previewMode={props.previewMode}
      onExitPreview={props.onExitPreview}
    />
  );
}
